import { api } from "@shared/api/client";

export type AgendaEventType = "evento" | "reunion" | "recordatorio" | "otro";

export type AgendaEvent = {
  id: number;
  usuario_id: number;
  usuario_nombre: string;
  usuario_correo: string;
  creado_por_id: number | null;
  creador_nombre: string | null;
  titulo: string;
  descripcion: string | null;
  fecha: string;
  hora_inicio: string | null;
  hora_fin: string | null;
  todo_el_dia: boolean;
  tipo: AgendaEventType;
  ubicacion: string | null;
  editable: boolean;
};

export type AgendaVacationMarker = {
  date: string;
  jornada: "completa" | "manana" | "tarde";
  usuario_id: number;
  usuario_nombre: string;
};

export type AgendaRestDay = {
  id: number;
  date: string;
  name: string;
};

export type AgendaPayload = {
  events: AgendaEvent[];
  vacations: AgendaVacationMarker[];
  rest_days: AgendaRestDay[];
};

export type AgendaEventInput = {
  usuario_id?: number;
  titulo: string;
  descripcion?: string | null;
  fecha: string;
  hora_inicio?: string | null;
  hora_fin?: string | null;
  todo_el_dia: boolean;
  tipo: AgendaEventType;
  ubicacion?: string | null;
};

export async function getAgenda(
  scope: "personal" | "admin",
  from: string,
  to: string,
  userId?: number | null,
  signal?: AbortSignal,
): Promise<AgendaPayload> {
  const base = scope === "admin" ? "/admin-panel/agenda" : "/rrhh/agenda";
  const { data } = await api.get<AgendaPayload>(base, {
    params: { from, to, user_id: scope === "admin" ? userId ?? undefined : undefined },
    signal,
  });
  return data;
}

export async function createAgendaEvent(
  scope: "personal" | "admin",
  payload: AgendaEventInput,
): Promise<AgendaEvent> {
  const base = scope === "admin" ? "/admin-panel/agenda" : "/rrhh/agenda";
  const { data } = await api.post<{ data: AgendaEvent }>(base, payload);
  return data.data;
}

export async function updateAgendaEvent(
  scope: "personal" | "admin",
  id: number,
  payload: AgendaEventInput,
): Promise<AgendaEvent> {
  const base = scope === "admin" ? "/admin-panel/agenda" : "/rrhh/agenda";
  const { data } = await api.put<{ data: AgendaEvent }>(`${base}/${id}`, payload);
  return data.data;
}

export async function deleteAgendaEvent(
  scope: "personal" | "admin",
  id: number,
): Promise<void> {
  const base = scope === "admin" ? "/admin-panel/agenda" : "/rrhh/agenda";
  await api.delete(`${base}/${id}`);
}
